import { render, staticRenderFns } from "./newborrowlist.vue?vue&type=template&id=0218fdf7&scoped=true&"
import script from "./newborrowlist.vue?vue&type=script&lang=js&"
export * from "./newborrowlist.vue?vue&type=script&lang=js&"
import style0 from "./newborrowlist.vue?vue&type=style&index=0&id=0218fdf7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218fdf7",
  null
  
)

export default component.exports